module.exports = __webpack_public_path__ + "stu-res/img/icon-4.ca076755.png";